import { render } from "./IconTrash.vue?vue&type=template&id=412b8d20&scoped=true"
const script = {}

import "./IconTrash.vue?vue&type=style&index=0&id=412b8d20&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-412b8d20"

export default script